import { render } from "./withdraw1.vue?vue&type=template&id=6b3aed0d&scoped=true"
import script from "./withdraw1.vue?vue&type=script&lang=js"
export * from "./withdraw1.vue?vue&type=script&lang=js"

import "./withdraw1.vue?vue&type=style&index=0&id=6b3aed0d&lang=less&scoped=true"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\记录\\2508幸运28\\xingyun_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b3aed0d"]])

export default __exports__